<template>
    <div>
        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-3">
                        {{ this.parentObject.pageTitle }}
                        <span class="page_title_value">
                            {{ this.parentObject.pageTitleValue }}
                        </span>
                    </h2>
                </v-row>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-card>
                        <div class="ma-5">
                            <v-subheader class="blue--text">
                                {{ $t('reportsparam.parameters') }}
                            </v-subheader>
                            <v-row>
                                <v-col cols="6" sm="6" class="pb-n5">
                                    <v-autocomplete outlined :label="this.$t('acknowledgement.selectacknowledgement')"
                                        type="text" dense :items="ackRecordList" v-model="formData.ackRecordId">
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="4" sm="4" class="pb-n5 mt-1">
                                    <v-checkbox input-value="true" :label="this.$t('reportstaffenquiry.activestaff')"
                                        v-model="activeStaff" value></v-checkbox>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>
                </v-container>
                <v-row>
                    <div class="pt-5">
                        <v-row>
                            <v-col>
                                <v-btn color="warning" style="width: 100px" @click="goHandler">
                                    {{ $t('button.go') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </v-row>
            </v-form>
        </v-container>
        <div v-if="isErr">
            <app-error v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }" v-on:closeError="isErr = $event" />
        </div>
    </div>
</template>
<script>
import ErrorDialog from "../../../components/common/ErrorDialog"

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-error': ErrorDialog
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('reportsparam.invalidemail')
                }
            },

            formData: {
                ackRecordId: null,
            },

            activeStaff: true,

            errMsg: "",
            isErr: false,

            ackRecordList: [],
        }
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        loadAckRecordListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: `/acknowledgements/all` })
                .then((res) => {
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.ackRecordList.push({
                            text: res.data.rec[i].ackName,
                            value: res.data.rec[i].id,
                        });
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        goHandler() {
            try {
                if (this.formData.ackRecordId == null || this.formData.ackRecordId == "" || this.formData.ackRecordId == undefined) {
                    this.isErr = true;
                    this.errMsg = "Invalid Input: Please select an Acknowledgement Record.";
                    return;
                }
                else {
                    this.$router.push({ name: "detailacknowledgementacceptance", params: { id: this.formData.ackRecordId, activestaff: this.activeStaff } });
                }
            } catch (e) {
                this.isErr = true;
                this.errMsg = e;
                return;
            }
        },
    },

    mounted() {
        this.loadAckRecordListHandler();
    },
}
</script>